module.exports = __webpack_public_path__ + "media/images/value_true-87318bd851790a8d2a04a5da9d126b04.png";